module.exports = __webpack_public_path__ + "img/adamant_golem_small.854ed086.png";